export { default as StreamIcon } from './StreamIcon';
export { default as SwitchIcon } from './SwitchIcon';
export { default as OasisIcon } from './OasisIcon';
export { default as OasisMinIcon } from './OasisMinIcon';
export { default as ScollbarIcon } from './ScollbarIcon';
export { default as BoostIcon } from './BoostIcon';
export { default as LinkIcon } from './LinkIcon';
export { default as LinkMinIcon } from './LinkMinIcon';
export { default as QuietIcon } from './QuietIcon';
export { default as QuietMinIcon } from './QuietMinIcon';
export { default as FusionIcon } from './FusionIcon';
export { default as FusionMinIcon } from './FusionMinIcon';
export { default as GuardIcon } from './GuardIcon';
export { default as GuardMinIcon } from './GuardMinIcon';
export { default as StreamMinIcon } from './StreamMinIcon';
export { default as BoostMinIcon } from './BoostMinIcon';
export { default as BannerIcon } from './BannerIcon';
export { default as XIcon } from './XIcon';
export { default as CloseIcon } from './CloseIcon';
export { default as AddIcon } from './AddIcon';
// 视频
export { default as RePlayIcon } from './RePlayIcon';
export { default as PlayIcon } from './PlayIcon';
export { default as PauseIcon } from './PauseIcon';
